import { useMicrophone } from "@/features/MicrophoneManager/hooks/useMicrophone";
import type { MicrophoneStatus } from "@/types/microphoneStatus";
import { HorizontalFlex, Loader, LoaderSize, Select, Space } from "@enxcs/dap-ui-stratos";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MicrophoneTest } from "../MicrophoneTest";

export interface MicrophoneSelectionProps {
  setSelectValueAudioType: (arg0: string) => void;
  defaultSelected?: string;
  onMicrophoneStatusChange?(status: MicrophoneStatus): void;
}

export const MicrophoneSelection = ({ setSelectValueAudioType, defaultSelected, onMicrophoneStatusChange }: MicrophoneSelectionProps) => {
  const { t } = useTranslation();

  const { error, stream, selectedMicrophone, isPending, devices, onSelectMicrophone } = useMicrophone({
    defaultSelected,
    startOnMount: true,
    switchOnDisconnection: true,
  });

  useEffect(() => {
    if (selectedMicrophone) {
      setSelectValueAudioType(selectedMicrophone.deviceId);
    }
  }, [selectedMicrophone, setSelectValueAudioType]);

  if (isPending) {
    return (
      <HorizontalFlex $justify={"center"} $align={"center"} $gap={Space.V8}>
        <Loader size={LoaderSize.V18} />
      </HorizontalFlex>
    );
  }

  return (
    <>
      <Select
        data-qa-id="new-recording-select-audio-input"
        label={t("newRecordingModal.audioInput")}
        value={selectedMicrophone?.label || t("microphoneFeature.selectDevice")}
        onChange={(e) => {
          onSelectMicrophone(e);
        }}
        options={devices}
      />
      <MicrophoneTest stream={stream} error={error} onMicrophoneStatusChange={onMicrophoneStatusChange} />
    </>
  );
};
